var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSearch(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.833496 8.78081C0.833496 4.39156 4.35381 0.833374 8.69633 0.833374C10.7817 0.833374 12.7816 1.67069 14.2562 3.16112C15.7308 4.65156 16.5592 6.67302 16.5592 8.78081C16.5592 13.1701 13.0389 16.7282 8.69633 16.7282C4.35381 16.7282 0.833496 13.1701 0.833496 8.78081ZM16.4291 15.1831L18.7708 17.0734H18.8115C19.2853 17.5523 19.2853 18.3287 18.8115 18.8076C18.3377 19.2864 17.5696 19.2864 17.0958 18.8076L15.1525 16.5803C14.9688 16.3952 14.8655 16.1439 14.8655 15.8817C14.8655 15.6196 14.9688 15.3682 15.1525 15.1831C15.5068 14.8312 16.0748 14.8312 16.4291 15.1831Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.059082953d56173b941a55913a687d55.svg";
export { ForwardRef as ReactComponent };